import React, { useContext, useEffect, useState } from 'react'
import {
  CButton,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CFormSelect,
  CFormInput,
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilTrash } from '@coreui/icons'
import CustomDescriptionBox from 'src/components/CustomDescriptionBox'
import ImageUploader from 'src/components/ImageUploader/ImageUploader'
import PlusIcon from '../../../assets/plus-icon.svg'
import AttachLink from '../attachLink'
import { GlobalContext } from 'src/views/context/GlobalState'
import { getThumbnail, validateLink } from 'src/views/utils/helper'
import Loading from 'react-fullscreen-loading'
import { AppContext } from 'src/views/context/app'
import useAxios from 'axios-hooks'
import { SYSTEM_METADATA_API } from 'src/views/utils/urls'
import TemplateAccordion from '../templateAccordion'
import { isEmpty } from 'lodash'
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import LinkIcon from '../../../assets/link-icon.svg'
// import FacebookColored from '../../../assets/facebook-colored.svg'
// import InstagramColored from '../../../assets/instagram-colored.svg'
// import LinkedInColored from '../../../assets/linkedin-colored.svg'
// import MessengerColored from '../../../assets/messenger-colored.svg'
// import PinterestColored from '../../../assets/pinterest-colored.svg'
// import QuoraColored from '../../../assets/quora-colored.svg'
// import RedditColored from '../../../assets/reddit-colored.svg'
// import SnapchatColored from '../../../assets/snapchat-colored.svg'
// import TelegramColored from '../../../assets/telegram-colored.svg'
// import TiktokColored from '../../../assets/tiktok-colored.svg'
// import TwitchColored from '../../../assets/twitch-colored.svg'
// import TwitterColored from '../../../assets/twitter-colored.svg'
// import WeChatColored from '../../../assets/wechat-colored.svg'
// import WhatsAppColored from '../../../assets/whatsapp-colored.svg'
// import YoutubeColored from '../../../assets/youtube-colored.svg'
import DeleteIcon from '../../../assets/delete-icon.svg'

const FitnessFooterModal = ({ componentData, modifyData, modalSpecificData, onCancel }) => {
  // const { isEdit } = modalSpecificData
  const { userSessionObj } = useContext(GlobalContext)
  const { loader, setLoader } = useContext(AppContext)

  const [imageS3key, setImageS3key] = useState('')
  const [errorData, setErrorData] = useState({})
  const [imageData, setImageData] = useState([])
  const [contactEmail, setContactEmail] = useState('')
  const [phoneNum, setPhoneNum] = useState('')
  const [copyrightText, setCopyrightText] = useState('')
  const [emailForm, setEmailForm] = useState({
    enabled: true,
    title: '',
    button_text: '',
    placeholder_text: '',
    link: {
      type: '',
      data: {},
    },
  })
  const [siteMap, setSiteMap] = useState([])
  const [link, setLink] = useState({ type: '', data: {} }) // default footer form subscribe btn link
  const [socialHandles, setSocialHandles] = useState([])
  const [linkModal, setLinkModal] = useState(false)
  const [siteMapIdx, setSiteMapIdx] = useState(0)
  const [subHeadingIndex, setSubHeadingIndex] = useState(0)

  const [{ data: categoryList, loading: categoryListLoading }] = useAxios({
    url: SYSTEM_METADATA_API,
    method: 'get',
  })

  const clearError = (type) => {
    let temp = errorData
    temp[`${type}`] = ''
    setErrorData({ ...temp })
  }

  useEffect(() => {
    setLoader(categoryListLoading)
  }, [categoryListLoading])

  useEffect(() => {
    const imgData = [
      {
        title: '',
        id: 'mdImage',
        width: 162,
        height: 63,
        divwidth: '19.9rem',
        divheight: '8.4rem',
        assetId: '',
        setAssetId: (id) => {},
        setImage: (obj) => {
          setImageS3key(obj?.s3Key)
        },
        onRemoveImg: () => {
          setImageS3key('')
        },
        imageUrl: '',
      },
    ]
    let tempdata = componentData.data
    // console.log(tempdata)

    setImageS3key(tempdata.image_s3key)
    setContactEmail(tempdata.email)
    setPhoneNum(tempdata.phone)
    setCopyrightText(tempdata.copyright_text)
    setSocialHandles(tempdata.social_handles)
    setEmailForm(tempdata.email_form)
    setSiteMap(tempdata.site_map)

    imgData[0]['assetId'] = tempdata.image_s3key
    imgData[0]['imageUrl'] = getThumbnail(
      userSessionObj?.session_data?.cf_domain_name,
      tempdata.image_s3key,
    )

    setImageData(imgData)
  }, [])

  const validateInfo = () => {
    let isFormValid = true
    let temp = {}

    if (imageS3key.trim().length === 0) {
      isFormValid = false
      temp.imageS3key = 'Upload Image!'
    }

    if (emailForm.enabled && emailForm.button_text.trim().length === 0) {
      isFormValid = false
      temp.emailFormbutton_text = 'Button Text Cannot be Empty!'
    }

    if (link.type && !validateLink(link).isValid) {
      isFormValid = false
      temp.link = validateLink(link).error
    }

    setErrorData({ ...temp })
    return isFormValid
  }

  // save component data
  const handleSave = () => {
    if (!validateInfo()) return

    let elementObj = {
      image_s3key: imageS3key,
      email: contactEmail,
      phone: phoneNum,
      copyright_text: copyrightText,
      social_handles: socialHandles,
      email_form: emailForm,
      site_map: siteMap,
    }

    modifyData(componentData.id, elementObj)
  }

  // delete social handle
  const deleteSocialHandle = (index) => {
    setSocialHandles((prevData) => prevData.filter((data, idx) => idx !== index))
  }
  // delete social handle
  const deleteSiteMap = (index) => {
    setSiteMap((prevData) => prevData.filter((data, idx) => idx !== index))
  }
  // add social handle
  const addSocialHandle = () => {
    setSocialHandles((prev) => [
      ...prev,
      {
        name: '',
        url: '',
      },
    ])
  }
  // change social item Name
  const changeSocialItemName = (value, idx) => {
    let tempSocialHandles = socialHandles
    tempSocialHandles[idx] = { ...tempSocialHandles[idx], name: value }
    setSocialHandles([...tempSocialHandles])
  }
  // change social item Url  // not working
  const changeSocialItemUrl = (value, idx) => {
    let tempSocialHandles = socialHandles
    tempSocialHandles[idx] = { ...tempSocialHandles[idx], url: value }
    setSocialHandles([...tempSocialHandles])
  }

  // change site map item Name
  const changeSiteMapItemText = (value, idx) => {
    let tempSiteMap = siteMap
    tempSiteMap[idx] = { ...tempSiteMap[idx], title: value }
    setSiteMap([...tempSiteMap])
  }

  // change site map sub heading text
  const changeSiteMapItemSubHeadingText = (value, idx, index) => {
    if (isEmpty(siteMap)) return
    let tempSiteMap = siteMap
    let subHeadingData = tempSiteMap[idx]?.sub_heading_data
    subHeadingData[index] = { ...subHeadingData[index], text: value }
    tempSiteMap[idx] = { ...tempSiteMap[idx], sub_heading_data: subHeadingData }
    setSiteMap([...tempSiteMap])
  }

  const [subLinkError, setsubLinkError] = useState('')
  // change site map sub heading link
  const changeSiteMapItemSubHeadingLink = (value, idx, index) => {
    if (isEmpty(siteMap)) return
    if (!validateLink(value).isValid) {
      setsubLinkError(validateLink(value).error)
      return
    }
    let tempSiteMap = siteMap
    let subHeadingData = tempSiteMap[idx]?.sub_heading_data
    subHeadingData[index] = { ...subHeadingData[index], link: value }
    tempSiteMap[idx] = { ...tempSiteMap[idx], sub_heading_data: subHeadingData }
    setSiteMap([...tempSiteMap])
    setLinkModal(false)
  }

  // link modal opener
  const linkAssignModal = (idx, index) => {
    setLinkModal(true)
    setLink(siteMap[idx]?.sub_heading_data[index]?.link)
    setSiteMapIdx(idx)
    setSubHeadingIndex(index)
  }

  // add site map
  const addSiteMap = () => {
    setSiteMap((prev) => [
      ...prev,
      {
        title: '',
        sub_heading_data: [
          {
            text: '',
            link: {
              type: '',
              data: {},
            },
          },
          {
            text: '',
            link: {
              type: '',
              data: {},
            },
          },
          {
            text: '',
            link: {
              type: '',
              data: {},
            },
          },
          {
            text: '',
            link: {
              type: '',
              data: {},
            },
          },
          {
            text: '',
            link: {
              type: '',
              data: {},
            },
          },
        ],
      },
    ])
  }

  let accordionItems = [
    {
      title: 'Add Logo',
      description: "Insert company's logo in the Footer",
      children: (
        <div
          style={{ backgroundColor: '#e5e5e5' }}
          className=" px-4 py-3 d-flex flex-column justify-content-center align-items-center"
        >
          <ImageUploader data={imageData} />
          <span className="mt-2" style={{ fontSize: '11px', color: '#707070' }}>
            160 px X 65 px , maximum size 2 MB
          </span>
          <div className="message-text error-message">
            <p>{errorData.imageS3key}</p>
          </div>
        </div>
      ),
      itemStyle: '',
    },
    {
      title: 'Edit Sitemap',
      description: 'Specify the Sitemap and respective links',
      children: (
        <div
          style={{ backgroundColor: '#e5e5e5', overflowX: 'auto' }}
          className=" px-4 py-3 d-flex"
        >
          {!isEmpty(siteMap) &&
            siteMap.map((sitemapitem, idx) => {
              return (
                <div
                  className="flex-shrink-0 position-relative"
                  style={{
                    width: '43%',
                    paddingRight: '9%',
                    borderRight: `${idx !== siteMap.length - 1 ? '1px #9b9494 solid' : 'none'}`,
                    marginLeft: `${idx === 0 ? '0' : '8%'} `,
                  }}
                  key={idx}
                >
                  <div
                    className={`position-absolute ${idx === 0 ? 'd-none' : 'd-block'}`}
                    onClick={() => deleteSiteMap(idx)}
                    style={{ right: '20%', top: '0', cursor: 'pointer' }}
                  >
                    <img src={DeleteIcon} alt="" style={{ width: '14px' }} />
                  </div>
                  <h6 style={{ fontSize: '13px' }} className="">
                    Title {idx + 1}
                  </h6>
                  <div style={{ width: '78%' }}>
                    <CustomDescriptionBox
                      limit={12}
                      rows={1}
                      value={sitemapitem.title}
                      onChange={(value) => changeSiteMapItemText(value, idx)}
                      style={{ fontSize: '10px', borderRadius: '3px' }}
                      limitFontSize={'11px'}
                    />
                  </div>
                  {!isEmpty(sitemapitem?.sub_heading_data) &&
                    sitemapitem?.sub_heading_data.map((subHeadingItem, index) => {
                      return (
                        <div
                          className="d-flex justify-content-between align-items-start mt-2"
                          key={index}
                        >
                          <div style={{ width: '78%' }}>
                            <CustomDescriptionBox
                              limit={25}
                              rows={1}
                              value={subHeadingItem.text}
                              onChange={(value) =>
                                changeSiteMapItemSubHeadingText(value, idx, index)
                              }
                              style={{ fontSize: '10px', borderRadius: '3px' }}
                              limitFontSize={'11px'}
                            />
                          </div>

                          <div
                            className="w-7 h-7 bg-[#20211c] d-flex justify-center items-center rounded-sm cursor-pointer"
                            onClick={() => linkAssignModal(idx, index)}
                          >
                            <img src={LinkIcon} alt="" className="w-3 h-3" />
                          </div>
                          {linkModal && (
                            <CModal visible={linkModal} size="md" alignment="center">
                              <CModalBody>
                                <h6 style={{ fontWeight: '700', fontSize: '12px' }}>ADD LINK</h6>
                                <AttachLink
                                  title=""
                                  linkData={link}
                                  id={'text1'}
                                  categoryData={
                                    categoryList
                                      ? categoryList?.data.filter(
                                          (info, idx) => info.type === 'category' && info.status,
                                        )
                                      : []
                                  }
                                  setLinkData={(value) => {
                                    setsubLinkError('')
                                    setLink(value)
                                  }}
                                />
                                <div className="message-text error-message">
                                  <p>{subLinkError}</p>
                                </div>
                              </CModalBody>
                              <CModalFooter style={{ borderTop: '0' }}>
                                <CButton
                                  style={{
                                    color: '#3a3838',
                                    backgroundColor: 'white',
                                    border: '1px solid #bdbdbd',
                                    borderRadius: '5px',
                                  }}
                                  onClick={() => setLinkModal(false)}
                                >
                                  Cancel
                                </CButton>
                                <CButton
                                  style={{
                                    color: 'white',
                                    backgroundColor: '#20211c',
                                    border: '1px solid #bdbdbd',
                                    borderRadius: '5px',
                                  }}
                                  onClick={() =>
                                    changeSiteMapItemSubHeadingLink(
                                      link,
                                      siteMapIdx,
                                      subHeadingIndex,
                                    )
                                  }
                                >
                                  Assign Link
                                </CButton>
                              </CModalFooter>
                            </CModal>
                          )}
                        </div>
                      )
                    })}
                </div>
              )
            })}
          {siteMap.length < 4 && (
            <div
              className="d-flex justify-content-center align-items-center cursor-pointer"
              style={{ height: '361px' }}
            >
              <div style={{ border: '1px solid #2172eb' }} className="relative h-full">
                <div
                  onClick={() => addSiteMap()}
                  className="absolute h-[32px] w-[32px] rounded-full bg-[#2172eb] top-[45%] -left-4 flex justify-center items-center"
                >
                  <img src={PlusIcon} className="w-[17px] h-[17px]" alt="plus icon" />
                </div>
              </div>
            </div>
          )}
        </div>
      ),
      itemStyle: 'mt-4',
    },
    {
      title: 'Add Contact Info & Copyright statement',
      description: 'Specify your contact information and copyright statement',
      children: (
        <div style={{ backgroundColor: '#e5e5e5' }} className=" px-4 py-3">
          <div className="">
            <h6 style={{ fontSize: '13px' }} className="">
              Email
            </h6>
            <CustomDescriptionBox
              limit={36}
              rows={1}
              value={contactEmail}
              onChange={(value) => setContactEmail(value)}
              style={{ fontSize: '12px' }}
              limitFontSize={'11px'}
            />
          </div>
          <div className="mt-1">
            <h6 style={{ fontSize: '13px' }}>Phone Number</h6>
            <CustomDescriptionBox
              limit={20}
              rows={1}
              value={phoneNum}
              onChange={(value) => setPhoneNum(value)}
              style={{ fontSize: '12px' }}
              limitFontSize={'11px'}
            />
          </div>
          <div className="mt-1">
            <h6 style={{ fontSize: '13px' }}>Copyright Statement</h6>
            <CustomDescriptionBox
              limit={45}
              rows={1}
              value={copyrightText}
              onChange={(value) => setCopyrightText(value)}
              style={{ fontSize: '12px' }}
              limitFontSize={'11px'}
            />
          </div>
        </div>
      ),
      itemStyle: 'mt-4',
    },
    {
      title: 'Add Social Media Links',
      description: 'Specify social links that you want to share with your viewers.',
      children: (
        <div style={{ backgroundColor: '#e5e5e5' }} className=" px-4 py-3">
          <div className="">
            <h6 style={{ fontSize: '13px' }} className="">
              Select Social Link
              <span style={{ marginLeft: '13%' }}>URL</span>
            </h6>
            <div>
              {socialHandles.map((socialitem, idx) => (
                <div
                  className="d-flex justify-content-between items-center mb-3"
                  key={`${socialitem.name}${idx}`}
                >
                  <CFormSelect
                    size="sm"
                    style={{ width: '25%' }}
                    aria-label="Social handle seclector"
                    defaultValue={socialitem.name}
                    onChange={(e) => changeSocialItemName(e.target.value, idx)}
                  >
                    <option>Select</option>
                    <option
                      disabled={socialHandles.find((social) =>
                        social.name === 'Facebook' ? true : null,
                      )}
                      value="Facebook"
                    >
                      Facebook
                    </option>
                    <option
                      disabled={socialHandles.find((social) =>
                        social.name === 'Instagram' ? true : null,
                      )}
                      value="Instagram"
                    >
                      Instagram
                    </option>
                    <option
                      disabled={socialHandles.find((social) =>
                        social.name === 'LinkedIn' ? true : null,
                      )}
                      value="LinkedIn"
                    >
                      LinkedIn
                    </option>
                    <option
                      disabled={socialHandles.find((social) =>
                        social.name === 'Facebook-messenger' ? true : null,
                      )}
                      value="Facebook-messenger"
                    >
                      Messenger
                    </option>
                    <option
                      disabled={socialHandles.find((social) =>
                        social.name === 'Pinterest' ? true : null,
                      )}
                      value="Pinterest"
                    >
                      Pinterest
                    </option>
                    <option
                      disabled={socialHandles.find((social) =>
                        social.name === 'Quora' ? true : null,
                      )}
                      value="Quora"
                    >
                      Quora
                    </option>
                    <option
                      disabled={socialHandles.find((social) =>
                        social.name === 'Reddit' ? true : null,
                      )}
                      value="Reddit"
                    >
                      Reddit
                    </option>
                    <option
                      disabled={socialHandles.find((social) =>
                        social.name === 'Snapchat' ? true : null,
                      )}
                      value="Snapchat"
                    >
                      Snapchat
                    </option>
                    <option
                      disabled={socialHandles.find((social) =>
                        social.name === 'Telegram' ? true : null,
                      )}
                      value="Telegram"
                    >
                      Telegram
                    </option>
                    <option
                      disabled={socialHandles.find((social) =>
                        social.name === 'Tiktok' ? true : null,
                      )}
                      value="Tiktok"
                    >
                      Tiktok
                    </option>
                    <option
                      disabled={socialHandles.find((social) =>
                        social.name === 'Twitch' ? true : null,
                      )}
                      value="Twitch"
                    >
                      Twitch
                    </option>
                    <option
                      disabled={socialHandles.find((social) =>
                        social.name === 'Twitter' ? true : null,
                      )}
                      value="Twitter"
                    >
                      Twitter
                    </option>
                    <option
                      disabled={socialHandles.find((social) =>
                        social.name === 'Weixin' ? true : null,
                      )}
                      value="Weixin"
                    >
                      WeChat
                    </option>
                    <option
                      disabled={socialHandles.find((social) =>
                        social.name === 'WhatsApp' ? true : null,
                      )}
                      value="WhatsApp"
                    >
                      WhatsApp
                    </option>
                    <option
                      disabled={socialHandles.find((social) =>
                        social.name === 'Youtube' ? true : null,
                      )}
                      value="Youtube"
                    >
                      Youtube
                    </option>
                  </CFormSelect>
                  <CFormInput
                    type="text"
                    size="sm"
                    style={{ width: '61%' }}
                    placeholder=""
                    aria-label="sm input example"
                    value={socialitem.url}
                    onChange={(e) => changeSocialItemUrl(e.target.value, idx)}
                  />
                  <div
                    className="w-[24px] h-[24px] d-flex justify-center items-center"
                    style={{ border: '1px solid #707070', borderRadius: '50%' }}
                    onClick={() => deleteSocialHandle(idx)}
                  >
                    <CIcon icon={cilTrash} size="md" />
                  </div>
                </div>
              ))}
            </div>
            {/* Add Link */}
            <div
              className="inline-flex justify-between items-center cursor-pointer"
              onClick={() => addSocialHandle()}
            >
              <div
                className="h-[24px] w-[24px] rounded-full bg-[#2172eb] flex justify-center items-center shadow"
                style={{ boxShadow: '2px 2px 4px 0 rgba(0, 0, 0, 0.3)' }}
              >
                <img src={PlusIcon} className="w-[15px] h-[15px]" alt="trashicon" />
              </div>
              <p className="text-xs text-[#2172eb] font-medium ml-1 mb-0">ADD LINK</p>
            </div>
            {/* Add Link Ending */}
          </div>
        </div>
      ),
      itemStyle: 'mt-4',
    },
    {
      title: 'Add Email Sign-up Form',
      description:
        'Specify the link to which you would like to redirect after clicking the banner of the template.',
      children: (
        <div style={{ backgroundColor: '#e5e5e5' }} className=" px-4 py-3">
          <div className="">
            <h6 style={{ fontSize: '13px' }} className="">
              Title
            </h6>
            <CustomDescriptionBox
              limit={50}
              rows={1}
              value={emailForm.title}
              onChange={(value) =>
                setEmailForm((prevState) => {
                  return {
                    ...prevState,
                    title: value,
                  }
                })
              }
              style={{ fontSize: '12px' }}
              limitFontSize={'11px'}
            />
          </div>
          <div className="mt-1">
            <h6 style={{ fontSize: '13px' }}>
              Button Text <span style={{ color: 'red' }}>*</span>
            </h6>
            <CustomDescriptionBox
              limit={20}
              rows={1}
              value={emailForm.button_text}
              onChange={(value) =>
                setEmailForm((prevState) => {
                  return {
                    ...prevState,
                    button_text: value,
                  }
                })
              }
              style={{ fontSize: '12px' }}
              limitFontSize={'11px'}
              isMandatory={true}
              errorText={errorData.emailFormbutton_text}
            />
          </div>
          <div className="mt-1">
            <h6 style={{ fontSize: '13px' }}>Placeholder Text</h6>
            <CustomDescriptionBox
              limit={25}
              rows={1}
              value={emailForm.placeholder_text}
              onChange={(value) =>
                setEmailForm((prevState) => {
                  return {
                    ...prevState,
                    placeholder_text: value,
                  }
                })
              }
              //   disabled={!ctaButton.enabled}
              limitFontSize={'11px'}
              style={{ fontSize: '12px' }}
            />
          </div>
          <AttachLink
            linkData={emailForm.link}
            id={'text1'}
            categoryData={
              categoryList
                ? categoryList?.data.filter((info, idx) => info.type === 'category' && info.status)
                : []
            }
            setLinkData={(value) => {
              clearError('ctaButtonLink')
              setEmailForm((prevState) => {
                return {
                  ...prevState,
                  link: value,
                }
              })
            }}
          />
          <div className="message-text error-message">
            <p>{errorData?.link}</p>
          </div>
        </div>
      ),
      itemStyle: 'mt-4',
      enableSwitch: true,
      switchChecked: emailForm.enabled,
      switchToggle: (event) => {
        let { checked } = event.target
        setEmailForm((prevState) => {
          return {
            ...prevState,
            enabled: checked,
          }
        })
      },
    },
  ]

  return (
    <>
      <CModal scrollable size="lg" className="" visible={true}>
        <Loading loading={loader} background={'rgba(60, 60, 60, 0.6)'} loaderColor="#efefef" />
        <CModalHeader className="d-flex justify-content-center" style={{ borderBottom: '0' }}>
          <p style={{ fontSize: '1.3rem' }}>
            <b style={{ fontWeight: '500' }}>Footer Editor</b>
          </p>
        </CModalHeader>
        <CModalBody
          style={{ minHeight: '72vh' }}
          className=" static-scrollbar-class d-flex flex-column justify-content-between"
        >
          <div className="d-flex justify-content-center">
            <div
              style={{ width: '82%' }}
              className="flex flex-column justify-content-center align-items-center"
            >
              <TemplateAccordion items={accordionItems} styles={''} />
            </div>
          </div>
        </CModalBody>
        <CModalFooter className="d-flex justify-content-center border-top-0">
          <div
            className="mt-4 d-flex align-items-end justify-content-between"
            style={{ width: '80%' }}
          >
            <span className="mt-2" style={{ fontSize: '12px' }}>
              * Leave a section blank to remove it from the component. Do not fill any details.
            </span>
            <CButton
              style={{ color: 'black', border: '1px solid black' }}
              className="mx-4 bg-white rounded-1 btn-focus-none"
              onClick={onCancel}
            >
              Cancel
            </CButton>
            <CButton
              style={{ backgroundColor: '#20211c' }}
              className="px-3 rounded-1 btn-focus-none"
              onClick={handleSave}
            >
              Save
            </CButton>
          </div>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default FitnessFooterModal
